module.exports = __webpack_public_path__ + "static/media/FAQsW.ff231c54.svg";